import React, { Component } from "react"
import MaterialModal from "../../MaterialModal"
import closeIcon from "app/styles/images/sp/close.svg"
import { Icon, Row } from "antd"

export default class DeleteModal extends Component {
  render() {
    const { onCancel, noReference, continueUpload, ...rest } = this.props
    return (
      <MaterialModal
        width={450}
        title="上传确认"
        className="upload-delete-modal"
        {...rest}
        footer={(
          <Row type="flex" justify="center" align="middle">
            <button
              className="upload-group-btn"
              onClick={() => continueUpload()}
            >
              否，开始上传
            </button>
            <button
              className="cancel-group-btn"
              onClick={() => onCancel()}
            >
              是，去选择
            </button>
          </Row>
        )}
      >
        <img
          className="pgx-modal-close"
          src={closeIcon}
          alt="关闭对话框"
          onClick={onCancel}
        />
        <div className="sub-title">
          {noReference && noReference.map((reference, index) => (
            <div key={index}>{reference}</div>
          ))}
        </div>
        <div className="warning">
          <Icon type="exclamation-circle-o" />
          以上分组未选择参照，是否选择？
        </div>
      </MaterialModal>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/components/normal/BasicModal/UploadModal/ValidateModal.js